import React from 'react'
import { Spinner } from 'components/ui'
import { ImSpinner9 } from 'react-icons/im'

const CustomIndicator = ({ fullscreen = false }) => {
    const wrapperClass = fullscreen
        ? 'min-h-screen w-full flex items-center justify-center'
        : 'flex items-center justify-center'

    return (
        <div className={wrapperClass}>
            <Spinner size={40} indicator={ImSpinner9} />
        </div>
    )
}

export default CustomIndicator
